module.exports = __webpack_public_path__ + "img/kd.7fe84b35.png";